import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const ButtonWrapper = styled.button`
  cursor: pointer;
  height: 2rem;
  width: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  outline: none;
  padding: 0.4rem 0.2rem;
  z-index: 999;

  ${({ theme }) => theme.mediaQueries.lg} {
    display: none;
  }
`;

const MenuElement = styled.div`
  background-color: ${({ isOpen, theme }) =>
    isOpen ? theme.colors.accent : theme.colors.white};
  height: 0.15rem;
  width: 100%;
  transform-origin: center;
  transition:
    background-color 0.2s ease,
    transform 0.2s ease;
`;

const MenuElementTop = styled(MenuElement)`
  transform: ${({ isOpen }) =>
    isOpen ? 'translateY(0.56rem) rotate(45deg)' : 'none'};
`;

const MenuElementBottom = styled(MenuElement)`
  transform: ${({ isOpen }) =>
    isOpen ? 'translateY(-0.5rem) rotate(-45deg)' : 'none'};
`;

const MobileMenuButton = ({ onClick, isOpen }) => (
  <ButtonWrapper onClick={onClick} aria-expanded={isOpen}>
    <MenuElementTop isOpen={isOpen} aria-hidden="true" />
    <MenuElementBottom isOpen={isOpen} aria-hidden="true" />
  </ButtonWrapper>
);

MobileMenuButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default MobileMenuButton;
